// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5b4c8377","477":"72dfba15","970":"f2732db1","976":"3a865fba"}[chunkId] + ".chunk.js";
};